import qs from "qs"
import History from "."

export const getQuery = (loc = History.location) => {
  return qs.parse(loc.search.replace("?", ""))
}

export const getSearchString = (obj) => {
  return qs.stringify(obj)
}

const searchString = {
  getQuery,
  getSearchString
}

export default searchString
